
/* eslint-disable */
import { createApp } from 'vue'
import App from './App.vue'
import router from "@/router";
import { loadModules } from "@/api/moduleRegistry";
import { installVersionCheck } from "@/utils/versionCheck";

// Kick off the module registry fetch as early as possible so router guards
// have a populated map by the time the first navigation resolves.
loadModules().catch(() => {});

const app = createApp(App);
app.use(router)
app.mount("#app");

// After the router is wired: detect fresh deploys and prompt open tabs
// to refresh. See src/utils/versionCheck.js for the rationale.
installVersionCheck(router);
